import { Component } from '@angular/core';

@Component({
  selector: 'cbx-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {}
